import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Beaker } from "lucide-react";

const RANGES = [
  { key: "7d", label: "7d" },
  { key: "30d", label: "30d" },
  { key: "90d", label: "90d" },
  { key: "all", label: "All" },
];

const COLORS = { A: "bg-cyan", B: "bg-pink text-white" };

export default function QuizStatsTile() {
  const [rng, setRng] = useState("30d");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/analytics/quiz", { params: { rng } })
      .then((r) => setData(r.data))
      .finally(() => setLoading(false));
  }, [rng]);

  const variants = data?.variants || [];
  const winner = variants.length
    ? [...variants].sort((a, b) => b.completion_rate - a.completion_rate)[0]
    : null;

  return (
    <div className="brut p-4 bg-white mt-6" data-testid="quiz-stats-tile">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <div className="flex items-center gap-2">
          <Beaker size={20} strokeWidth={3} />
          <h3 className="font-display text-2xl uppercase">Quiz A/B test</h3>
        </div>
        <div className="flex gap-1 flex-wrap">
          {RANGES.map((r) => (
            <button
              key={r.key}
              onClick={() => setRng(r.key)}
              className={`brut-btn px-2 py-1 text-xs ${rng === r.key ? "bg-yellow" : "bg-white"}`}
              data-testid={`quiz-range-${r.key}`}
            >
              {r.label}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="text-sm opacity-60 text-center py-6">Loading variants…</div>
      ) : variants.length === 0 ? (
        <div className="text-sm opacity-60 text-center py-6">No quiz traffic yet.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {variants.map((v) => {
            const isWinner = winner && v.variant.key === winner.variant.key && v.started > 0;
            return (
              <div
                key={v.variant.key}
                className={`brut-sm p-3 ${COLORS[v.variant.key] || "bg-paper"}`}
                data-testid={`quiz-variant-${v.variant.key}`}
              >
                <div className="flex items-center justify-between">
                  <div className="font-display text-xl uppercase">Variant {v.variant.key}</div>
                  {isWinner && (
                    <span className="tag-sticker bg-green text-xs">Winning</span>
                  )}
                </div>
                <div className="text-xs italic opacity-80 mt-1">"{v.variant.headline}"</div>
                <div className="grid grid-cols-3 gap-2 mt-3">
                  <div>
                    <div className="text-[10px] uppercase font-bold opacity-70">Started</div>
                    <div className="font-display text-2xl">{v.started}</div>
                  </div>
                  <div>
                    <div className="text-[10px] uppercase font-bold opacity-70">Completed</div>
                    <div className="font-display text-2xl">{v.completed}</div>
                  </div>
                  <div>
                    <div className="text-[10px] uppercase font-bold opacity-70">Conv %</div>
                    <div className="font-display text-2xl">{v.completion_rate}%</div>
                  </div>
                </div>
                <div className="flex gap-3 mt-2 text-xs font-bold">
                  <span data-testid={`quiz-${v.variant.key}-boggy`}>🐸 {v.boggy}</span>
                  <span data-testid={`quiz-${v.variant.key}-fox`}>🦊 {v.fox}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
